import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export function SavedPlansPage({ user, isPremium }: { user: any, isPremium: boolean }) {
  const navigate = useNavigate()
  const [plans, setPlans] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [renaming, setRenaming] = useState<string | null>(null)
  const [newName, setNewName] = useState('')

  useEffect(() => {
    if (!user) { navigate('/auth'); return }
    loadPlans()
  }, [user])

  const loadPlans = async () => {
    setLoading(true)
    const { data } = await supabase.from('plans').select('*').eq('user_id', user.id).order('updated_at', { ascending: false })
    setPlans(data || [])
    setLoading(false)
  }

  const deletePlan = async (id: string) => {
    if (!window.confirm('Eliminare questo piano?')) return
    await supabase.from('plans').delete().eq('id', id)
    setPlans(plans.filter(p => p.id !== id))
  }

  const renamePlan = async (id: string) => {
    if (!newName.trim()) return
    await supabase.from('plans').update({ title: newName }).eq('id', id)
    setPlans(plans.map(p => p.id === id ? { ...p, title: newName } : p))
    setRenaming(null)
    setNewName('')
  }

  const loadPlan = (plan: any) => {
    navigate('/plan', { state: { wizardState: plan.wizard_state, planId: plan.id } })
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F8F9FA' }}>
      <header style={{ backgroundColor: 'white', borderBottom: '1px solid #E5E7EB', padding: '12px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1 style={{ fontSize: 20, fontWeight: 'bold', color: '#111827', margin: 0 }}>📚 I miei piani</h1>
        <button onClick={() => navigate('/')} style={{ fontSize: 13, color: '#6B7280', backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: 8, padding: '8px 16px', cursor: 'pointer' }}>
          + Nuovo piano
        </button>
      </header>

      <div style={{ maxWidth: 700, margin: '0 auto', padding: '24px 16px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#9CA3AF' }}>Caricamento...</div>
        ) : plans.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 60 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📋</div>
            <p style={{ color: '#6B7280', fontSize: 16 }}>Nessun piano salvato</p>
            <button onClick={() => navigate('/')} style={{ marginTop: 16, backgroundColor: '#1c3fff', color: 'white', border: 'none', borderRadius: 10, padding: '10px 24px', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
              Crea il tuo primo piano
            </button>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {plans.map(plan => (
              <div key={plan.id} style={{ backgroundColor: 'white', borderRadius: 12, padding: '16px 20px', border: '1px solid #E5E7EB', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                <div style={{ flex: 1 }}>
                  {renaming === plan.id ? (
                    <div style={{ display: 'flex', gap: 8 }}>
                      <input
                        value={newName}
                        onChange={e => setNewName(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && renamePlan(plan.id)}
                        autoFocus
                        style={{ flex: 1, border: '1px solid #1c3fff', borderRadius: 6, padding: '4px 8px', fontSize: 14 }}
                      />
                      <button onClick={() => renamePlan(plan.id)} style={{ backgroundColor: '#1c3fff', color: 'white', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 13 }}>✓</button>
                      <button onClick={() => setRenaming(null)} style={{ backgroundColor: '#F3F4F6', color: '#6B7280', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 13 }}>✕</button>
                    </div>
                  ) : (
                    <>
                      <div style={{ fontWeight: 600, color: '#111827', fontSize: 15 }}>{plan.title}</div>
                      <div style={{ fontSize: 12, color: '#9CA3AF', marginTop: 2 }}>
                        Aggiornato: {new Date(plan.updated_at).toLocaleDateString('it-IT')}
                      </div>
                    </>
                  )}
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => loadPlan(plan)} style={{ backgroundColor: '#EEF2FF', color: '#1c3fff', border: 'none', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                    Apri
                  </button>
                  <button onClick={() => { setRenaming(plan.id); setNewName(plan.title) }} style={{ backgroundColor: '#F9FAFB', color: '#6B7280', border: '1px solid #E5E7EB', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 13 }}>
                    ✏️
                  </button>
                  <button onClick={() => deletePlan(plan.id)} style={{ backgroundColor: '#FEF2F2', color: '#EF4444', border: 'none', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 13 }}>
                    🗑️
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
